module.exports = __webpack_public_path__ + "static/img/IMG_20150610_223949.fa1a94a2.jpg";